/**
 * Пределы домена для компонентов: рамка и окно дат из бренда `/cabinet/site`.
 *
 * Бренд читается до первого кадра (`siteCache`), поэтому карта строится сразу
 * со своей рамкой — без кадра чужой воды, который потом пришлось бы прижимать.
 */
import { useMemo } from 'react'

import { useSiteBrand } from '../i18n'
import { NO_LIMITS, type DomainLimits } from './limits'

export function useDomainLimits(): DomainLimits {
  const brand = useSiteBrand()
  const frame = brand?.frame ?? null
  const period = brand?.period ?? null
  return useMemo(
    () => (frame || period ? { frame, period } : NO_LIMITS),
    [frame, period],
  )
}
